// @flow
import { useState, useEffect } from 'react';
import { getAPIDomain } from 'shared/lib/clientSettings';
import type { Region } from 'shared/types';

export default function usePages(
  region: Region,
  start: number,
  year: number,
  limit: number
) {
  const [isFetching, setIsFetching] = useState(true);
  const [data, setData] = useState({ posts: [], totalCount: 1, years: []});

  useEffect(() => {
    const filteredYear = year < 0 ? '' : year;
    const skip = start * limit;
    const fetchDomain = getAPIDomain(region) || '';

    setIsFetching(true);

    // Fetch data.
    fetch(`${fetchDomain}/api/press-room/postlist?region=${region}&limit=${limit}&start=${skip}&year=${filteredYear}`)
      .then(res => res.json())
      .then((res) => {
        setData({
          posts: res.pages,
          totalCount: res.totalCount,
          years: res.years
        });
      })
      .catch(() => {
        // Ignore error for now
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [region, start, year, limit]);

  return {
    isFetching,
    ...data
  };
}